export function getNaturalWidth() {
  const imStore = window.SirvHSE.imageStore;
  const im = Object.values(imStore)[0];
  return im.naturalWidth;
}

export function getNaturalHeight() {
  const imStore = window.SirvHSE.imageStore;
  const im = Object.values(imStore)[0];
  return im.naturalHeight;
}

export function getNaturalAspect() {
  return getNaturalHeight() / getNaturalWidth();
}
